module.exports = __webpack_public_path__ + "img/h8.47fdf589.jpg";